import request from '../../utils/request'
import config from '../../config/config'

// 新建公司
export function addCompany(data) {
  return request({
    url: config.baseURL + '/api/companies/add',
    method: 'post',
    data
  })
}

// 获取公司列表
export function getCompanyList(data) {
  return request({
    url: config.baseURL + '/api/companies/list',
    method: 'post',
    data
  })
}

// 修改公司信息
export function updateCompany(data) {
  return request({
    url: config.baseURL + '/api/companies/update',
    method: 'post',
    data
  })
}

// 删除公司
export function deleteCompany(data) {
  return request({
    url: config.baseURL + '/api/companies/delete',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/company/index.js